import http from "./httpService";

export function getFooterData() {
  return http.get(`/PublicApi/GetFooterData`).then(({ data }) => data?.data);
}
